<template>
  <div class="w-full h-full grid md:grid-cols-7">
    <RegisterComponent class="relative col-span-4" />
    <WelcomeComponent class="relative col-span-3 hidden md:flex" />
  </div>
</template>

<script>
import RegisterComponent from '../components/appComponent/RegisterComponent.vue'
import WelcomeComponent from '../components/appComponent/WelcomeComponent.vue'

export default {
  components: {
    WelcomeComponent,
    RegisterComponent,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
